import React from "react";
import PropTypes from "prop-types";
import DrawSytles from "./DrawStyles";
import TrimbleMapsDrawControl from "@trimblemaps/trimblemaps-draw";
import { withMapContext } from "./MapContext";
import { getSetMapDrawEventKey } from "../utils/drawEventUtils";

function assertTrimbleDrawingToolsMapId(mapId) {
  if (!mapId) {
    throw new Error(
      'Trimble DrawingTools: "mapId" is required and must be non-empty. Set <Map mapId="..."> (mapId is provided via MapContext) or pass mapId explicitly; it must match DrawingToolbox mapId for the same map.',
    );
  }
}

class DrawTool extends React.Component {
  draw = null;

  componentDidMount() {
    assertTrimbleDrawingToolsMapId(this.props.mapId);
    this.draw = new TrimbleMapsDrawControl({
      boxSelect: true,
      displayControlsDefault: false,
      styles:DrawSytles(this.props.defaultThemeColor)
    });

    this.props.map.addControl(this.draw, "top-left");
    this.setDrawObject();
  }

  setDrawObject = () => {
    if (!this.props.eventHub) return;
    assertTrimbleDrawingToolsMapId(this.props.mapId);
    const eventKey = getSetMapDrawEventKey(this.props.mapId);
    this.props.eventHub.emit(eventKey, {
      map: this.props.map,
      draw: this.draw,
      drawComplete: this.props.onDrawingComplete,
    });
  };

  shouldComponentUpdate(nextProps) {
    this.setDrawObject();
    return false;
  }

  render() {
    return null;
  }
}

DrawTool.propTypes = {
  mapId: PropTypes.string.isRequired,
  map: PropTypes.object,
  eventHub: PropTypes.object,
  defaultThemeColor: PropTypes.string,
  onDrawingComplete: PropTypes.func,
};

export default withMapContext(DrawTool);
